import { BaseModel } from "sjs-base-model";
import CampaignMappingSourceModel from "./CampaignMappingSourceModel";

export default class CampaignMappingDataHitsModel extends BaseModel {
  /*
   * Client-Side properties (Not from API)
   */
  // noneApiProperties = null;
  // response getting from the api

  _id = "";
  _index = "";
  _score = 0.0;
  _source = [CampaignMappingSourceModel];

  constructor(data) {
    super();

    this.update(data);
  }
}
